import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const PageError = () => {
  const { errortype } = useParams();
  const [errorNum, setErrorNum] = useState(null);

  useEffect(() => {
    switch (errortype) {
      case 'unauthorized':
        setErrorNum(401);
        break;
      case 'notFound':
        setErrorNum(404);
        break;
      case 'internalServer':
        setErrorNum(500);
        break;
      default:
        break;
    }
  }, [errortype]);

  console.log('errortype', errortype);
  return (
    <div className="errorpage">
      <div className='errorpage-number'>{errorNum}</div>
      <div className='errorpage-type'>{errortype.charAt(0).toUpperCase() + errortype.slice(1)}</div>
    </div>
  );
};

export default PageError;
